import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';

import './_yup.extensions';

import { validateDateOfBirth } from 'services/validation';
import { DATE_VALID } from 'settings/birthdayValidValues';
import {
  CELLPHONE_FR_LENGTH_REGEX,
  CELLPHONE_FR_REGEX,
  CELLPHONE_UK_LENGTH_REGEX,
  CELLPHONE_UK_REGEX,
  FIRSTNAME_REGEX,
  LASTNAME_REGEX,
} from 'settings/regex';

export default (isUk: boolean, t: TFunction): BaseSchema =>
  Yup.object().shape({
    email: Yup.string()
      .required(t('LABEL_ERROR_EMAIL_REQUIRED', { ns: 'translation' }))
      .email(t('LABEL_ERROR_INVALID_EMAIL', { ns: 'translation' }))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC', { ns: 'translation' })),
    civility: Yup.string().required(
      t('LABEL_ERROR_TITLE_REQUIRED', { ns: 'translation' })
    ),
    lastName: Yup.string()
      .required(t('LABEL_ERROR_SURNAME_REQUIRED', { ns: 'translation' }))
      .min(2, t('LABEL_ERROR_SURNAME_LENGTH'))
      .max(isUk ? 32 : 38, t('LABEL_ERROR_SURNAME_MAX', { ns: 'translation' }))
      .matches(
        LASTNAME_REGEX,
        t('LABEL_ERROR_SURNAME_MUST_LETTERS', { ns: 'translation' })
      ),
    firstName: Yup.string()
      .required(t('LABEL_ERROR_FIRST_NAME_REQUIRED', { ns: 'translation' }))
      .min(2, t('LABEL_ERROR_FIRST_NAME_LENGTH'))
      .max(
        isUk ? 32 : 38,
        t('LABEL_ERROR_FIRST_NAME_MAX', { ns: 'translation' })
      )
      .matches(
        FIRSTNAME_REGEX,
        t('LABEL_ERROR_FIRST_NAME_MUST_LETTERS', { ns: 'translation' })
      ),
    cellPhone: Yup.string()
      .matches(
        isUk ? CELLPHONE_UK_LENGTH_REGEX : CELLPHONE_FR_LENGTH_REGEX,
        t('LABEL_ERROR_CELLPHONE_NUMBER_LENGTH', { ns: 'translation' })
      )
      .matches(
        isUk ? CELLPHONE_UK_REGEX : CELLPHONE_FR_REGEX,
        t('LABEL_ERROR_CELLPHONE_NUMBER_REGEX', {
          ns: 'translation',
        })
      )
      .when('smsOption', {
        is: '1',
        then: Yup.string().required(
          t('LABEL_ERROR_CELLPHONE_REQUIRED', { ns: 'translation' })
        ),
      }),
    dateOfBirth: Yup.string().test(
      'dateOfBirth',
      t('LABEL_BIRTHDAY_INVALID', { ns: 'translation' }),
      function (value) {
        if (!value) return true;

        const [day, month, year] = value.split('/');
        const validState = validateDateOfBirth(
          parseInt(month),
          parseInt(day),
          parseInt(year)
        );

        return validState === DATE_VALID;
      }
    ),
    smsOption: Yup.string().required(t('LABEL_ERROR_WISH_REQUIRED')),
    partOption: Yup.string().required(t('LABEL_ERROR_WISH_REQUIRED')),
    turnstileToken: Yup.string().turnstileRequired(
      t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
    ),
  });
